<template>
  <div class="home">
    <div class="home__toc d-flex flex-column justify-content-center border-bottom">
      <div class="container">
        <div class="bg-white p-5 my-5">
          <h1 class="home__toc__heading text-center font-weight-normal">
            {{ $config.get('project.name') }} - {{ $config.get('app.name') }}
          </h1>
          <ul>
            <li v-for="{ id, anchor, title, isEmpty } in charts" :key="id">
              <a href="#" v-scroll-to="anchor" :class="{ 'text-muted': isEmpty }">
                {{ title }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="home__charts">
      <div class="home__charts__toc">
        <bullets-toc :charts="nonEmptyCharts" class="m-2" />
      </div>
      <div v-for="({ component, chart, id, name }) in nonEmptyCharts" class="home__charts__wrapper border-bottom" :key="id">
        <div class="container py-5" :id="id">
          <div class="row">
            <div class="col-12 col-lg-8 my-2">
              <component :is="component" :chart="chart" :social-mode="socialModes[id]" :no-footer="noFooters[id]" class="home__charts__wrapper__component border"></component>
            </div>
            <div class="col home__charts__wrapper__embed my-2">
              <ul class="nav nav-tabs mb-4">
                <li class="nav-item">
                  <span class="nav-link active">
                    Embed
                  </span>
                </li>
                <li class="nav-item ml-auto">
                  <a class="nav-link" :href="chartAbsolutePath(name)" target="_blank">
                    <fa icon="external-link-alt" class="mr-1" />
                    In a new window
                  </a>
                </li>
              </ul>
              <label :for="`input-${id}`">Absolute URL:</label>
              <input type="text" class="ml-auto form-control" readonly :id="`input-${id}`" :value="chartAbsolutePath(name)" />
              <embed-form :url="chartAbsolutePath(name)" :height="330" no-preview class="overflow-hidden mt-4" no-title />
              <b-form-checkbox v-model="socialModes[id]" class="mb-2">
                <span class="font-weight-bold">Social mode</span> <span class="text-muted">(dark background, no footer)</span>
              </b-form-checkbox>
              <b-form-checkbox v-model="noFooters[id]">
                <span class="font-weight-bold">No footer</span>
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filter from 'lodash/filter'
import find from 'lodash/find'
import { routes, ChartRoute } from '../router'

import BulletsToc from '../components/BulletsToc.vue'

export default {
  name: 'Home',
  components: {
    BulletsToc
  },
  data () {
    return {
      socialModes: {},
      noFooters: {}
    }
  },
  methods: {
    chartAbsolutePath (name) {
      const chart = find(routes, { name })
      const query = { socialMode: !!this.socialModes[chart.id], noFooter: !!this.noFooters[chart.id] }
      const route = this.$router.resolve({ name, query })
      const base = window.location.href.split('#/').shift()
      return `${base}${route.href}`
    }
  },
  computed: {
    charts () {
      return filter(routes, route => route instanceof ChartRoute)
    },
    nonEmptyCharts () {
      return filter(this.charts, route => !route.isEmpty)
    }
  }
}
</script>

<style lang="scss">
  .home {
    // Generic header height
    padding-top: 72px;

    &__toc {
      min-height: 90vh;
      background: repeating-linear-gradient(-55deg, #fff, #fff 1px, #ebebeb 3px, #ebebeb 3px);

      &__heading {
        padding-bottom: 3rem;
      }
    }

    &__charts {

      &__toc {
        z-index: 1000;
        position: sticky;
        top: calc(50% - 75px);
        height: 0;
        text-align: right;
      }

      &__wrapper {

        &__component {
          max-width: 690px;
        }

        &__embed {
          font-size: 0.9rem;

          label, .btn {
            font-size: inherit;
          }

          .embed-form > .container-fluid {
            padding: 0;
          }
        }
      }
    }
  }

</style>
